/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class ErrorsHelper {

}
